// extracted by mini-css-extract-plugin
module.exports = {"root":"LoginPromo_root__1ABUt","link":"LoginPromo_link__Dewvk"};